import React from "react";
import ResumeTitle from "./ResumeTitle";
import { MdWork } from "react-icons/md";
import { GiGraduateCap } from "react-icons/gi";
import ResumeCard from "./ResumeCard";
import { isItalianDevice } from "../../utils/utils";

const Education = () => {
  return (
    <div className="w-full grid grid-cols-9 px-6">
      <div className="col-span-9 md:col-span-4">
        <ResumeTitle
          title={isItalianDevice() ? "Esperienza" : "Experience"}
          icon={<MdWork />}
        />
        <ResumeCard
          badge={isItalianDevice() ? "2019 - now" : "2019 - now"}
          title="Software Developer"
          subTitle="Insoft SRL"
          des="Flutter, Android SDK and React developer."
        />
      </div>
      <div className="w-full h-full hidden lgl:flex justify-center items-center">
        <span className="w-[1px] h-full bg-zinc-800 inline-flex"></span>
      </div>
      <div className="col-span-9 md:col-span-4">
        <ResumeTitle
          title={isItalianDevice() ? "Studi" : "Education"}
          icon={<GiGraduateCap />}
        />
        <ResumeCard
          badge="2016 - 2019"
          title="Università degli Studi di Udine"
          subTitle="Udine, Italy"
          des={
            isItalianDevice()
              ? "Laurea triennale in informatica"
              : "Bachelor's degree in Computer Science"
          }
        />
      </div>
    </div>
  );
};

export default Education;
